'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

exports.default = isOnline;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isOnline() {
    var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/favicon.ico';

    // Handle IE and more capable browsers
    var xhr = new (window.ActiveXObject || XMLHttpRequest)('Microsoft.XMLHTTP');

    // Open new request as a HEAD to the root hostname with a random param to bust the cache
    xhr.open('HEAD', '//' + window.location.host + path + '?rand=' + Math.floor((1 + Math.random()) * 0x10000), true);

    // Issue request and handle response
    return new _promise2.default(function (resolve) {
        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4) {
                if (xhr.status >= 200 && (xhr.status < 300 || xhr.status === 304)) {
                    return resolve(true);
                }
                resolve(false);
            }
        };
        xhr.send(null);
    });
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/isOnline.js
// module id = 8AIN
// module chunks = 46